<template>
  <div>
    <el-input
      class="ps-2 mb-2"
      size="small"
      @input="searchKeyChanged"
      v-model="searchKey"
      placeholder="Tìm kiếm"
    ></el-input>
    <div class="d-flex p-2 flex-column overflow-auto " style="height: 350px">
      <div v-for="(item) in getContactView()" :key="item.id">
        <div class="d-flex py-2">
          <el-checkbox v-model="item.isCheck"
                       @change="selectItem(item)" />
          <el-avatar :size="24" :src="item.avatar" class="ms-3" />
          <div class="font-size-16 text-1-line mx-1">{{ item.displayName }}</div>
        </div>
      </div>
    </div>
    <div class="divider-custom" />
    <el-button type="primary" size="mini" class="float-end mt-2" @click="sendEventBusinessCard">Gửi</el-button>
  </div>
</template>

<script>
export default {
  name: "BusinessCard",
  props: {
    conversation: {
      type: Object
    }
  },
  data() {
    return {
      contacts: [],
      friendIds: [],
      searchKey: ""
    };
  },


  methods: {
    getContactView() {
      if (this.searchKey.trim().length === 0) {
        return this.contacts;
      } else {
        return this.contacts.filter(s => s.displayName.toLowerCase().includes(this.searchKey.toLowerCase()));
      }
    },
    searchKeyChanged() {
      this.getContactView();
    },
    sendEventBusinessCard() {
      this.contacts.forEach(s => s.isCheck = false);
      this.$emit("sendBusinessCard", this.friendIds);
      this.friendIds = [];
    },
    selectItem(item) {
      if (item.isCheck) this.friendIds.push(this.contacts.find(s => s.id === item.id).id);
      else this.friendIds.splice(this.contacts.indexOf(item.id), 1);
    },
    getContacts() {
      this.$http
        .get("/api/contact/filter", {
          params: {
            searchKey: "",
            accountId: this.conversation.accountId,
            page: 0,
            pageSize: 10000
          }
        })
        .then(resp => {
          resp.data.content.forEach(s => s.isCheck = false);
          this.contacts = resp.data.content;
        });
    }
  },
  created() {
    this.getContacts();
  }
};
</script>

<style scoped>


</style>